import { Link } from 'react-router-dom';
import { Check, PartyPopper } from 'lucide-react';

export default function PaymentSuccessPage() {
  return (
    <div className="page-content min-h-screen flex items-center justify-center bg-[#FDFBEC] px-4">
      <div className="pattern-bg" />
      <div className="neo-card max-w-md w-full p-8 text-center bg-white relative z-10" data-testid="payment-result">
        <div className="w-16 h-16 rounded-full bg-[#39FF14]/20 border-2 border-[#39FF14] flex items-center justify-center mx-auto mb-4">
          <Check size={32} strokeWidth={3} className="text-green-700" />
        </div>
        <PartyPopper size={24} className="text-[#FFDE00] mx-auto mb-2" />
        <h1 className="font-['Fredoka'] text-3xl font-black text-[#0A0A0A] mb-2" data-testid="payment-success-title">Thank You!</h1>
        <p className="text-base text-[#4B5563] font-['Nunito'] mb-6">
          Your generous tip keeps Retro Playground TV running.
          You're helping families enjoy classic shows!
        </p>
        <p className="text-xs text-[#4B5563] font-['Nunito'] mb-6 italic">
          If your PayPal payment succeeded, you'll receive a confirmation email from PayPal.
        </p>
        <Link to="/" className="neo-btn inline-block px-8 py-3 rounded-xl bg-[#FF3860] text-white" data-testid="go-home-btn">
          Back to Shows
        </Link>
      </div>
    </div>
  );
}
